
import { ActionWith } from 'common/interfaces/action-with';
import { ThemeToneInterface, ThemeType } from '../../../components/theme-provider/interfaces';
import { PersistedStorageActionTypes } from './types';


function setTheme(theme: ThemeType): ActionWith<ThemeType> {
  return {
    type: PersistedStorageActionTypes.SET_THEME,
    payload: theme,
  };
}

function setThemeTone(theme: ThemeToneInterface): ActionWith<ThemeToneInterface> {
  return {
    type: PersistedStorageActionTypes.SET_THEME_TONE,
    payload: theme,
  };
}

function setSelectedCompanyId(id: number): ActionWith<number> {
  return {
    type: PersistedStorageActionTypes.SET_SELECTED_COMPANY_ID,
    payload: id,
  };
}

export const PersistedStorageActions = {
  setTheme,
  setThemeTone,
  setSelectedCompanyId,
};
